import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,_vm._b({key:_vm.currentPlaceholder,attrs:{"src":_vm.currentPlaceholder,"max-height":_vm.dimension,"max-width":_vm.maxWidth},on:{"error":_vm.nextPlaceholder}},'v-img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }